import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import DotSvg from '../../../svg/DotSvg';
import { setWholeFocusProduct } from '../../../store/focuspage/focuspageSlice';
import CrossArrow from '../../../svg/CrossArrow';
import { deleteFocusProductThunk, getDataForFocusThunk } from '../../../store/focuspage/focuspageThunk';
import Delete from '../../../svg/Delete';
import { setDeleteAlert } from '../../../store/alert/alertSlice';
import EditIcon from '../../../svg/EditSvg';

export default function ProductRedirectCard({ txt, link, dotimgclss, item, isDelete }) {
    const token = localStorage.getItem('dizeeToken');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(getDataForFocusThunk({ token: token }))
    }, [])

    const handleProductEditClick = () => {
        let product = item.product?.[0]
        navigate('/focus-page/product-type/edit-content', {
            state: {
                ...product,
                extension: item?.extension
            }
        });
    }

    const handleProductEditClick1 = () => {
        navigate('/focus-page/product-type/edit-multi-content', {
            state: {
                productContent: item?.product,
                extension: item?.extension,
                page: item?.page,
            }
        });
    }

    return (
        <div className='p-4 py-6 flex w-full justify-between items-center'>
            <div className='flex items-center'>
                <span className='text-white'>{txt}</span>
                {dotimgclss && (

                    <DotSvg width={6} height={6} color={'red'} className='ml-2' />

                )}
            </div>
            <div className="flex flex-row items-center gap-x-[15px]">
                <button onClick={() => {
                    dispatch(setWholeFocusProduct(item))
                    navigate(link)
                }} >
                    <CrossArrow className='h-[14px] w-[14px]  cursor-pointer' />
                    {/* <img src={plus} alt='plus'  /> */}
                </button>
                <button onClick={() => {
                    // dispatch(setWholeFocusEvent(item))
                    // navigate(link)
                    if (link == '/focus-page/product-page') {
                        handleProductEditClick()
                    } else {
                        handleProductEditClick1();
                    }
                }} >
                    <EditIcon className='h-[14px] w-[14px]  cursor-pointer' />
                </button>
                {
                    isDelete &&
                    <button onClick={() => {

                        dispatch(setDeleteAlert({
                            type: 'product',
                            data: {
                                token, payload: {
                                    ...item
                                }
                            }
                        }));

                        // dispatch(deleteFocusProductThunk({
                        //     token, payload: {
                        //         ...item
                        //     }
                        // }))
                    }} >
                        {/* <CrossArrow className='h-[14px] w-[14px]  cursor-pointer' /> */}
                        <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                    </button>
                }
            </div>
        </div>
    );
}
